<template>
  <div class="base-section sm oldTypography">
    <div class="container content">
      <div class="invoice">
        <div class="invoice__title cf">
          <h1 
            class="success mb-4 font-semibold text-[22px]"
          >
            <i class="icon icon-c-check white-text"></i>
            {{ $t('widgets.PagesThankYou.title') }}
            <br class="rwd-break">
            {{ $t('widgets.PagesThankYou.subTitle') }}
          </h1>
        </div>
        <div class="invoice__contents cf">
          <h2 class="red-text">
            {{ $t('widgets.PagesThankYou.sectionTitle') }}
          </h2>

          <ol>
            <li>
              <div v-html="$t('widgets.PagesThankYou.sectionDescr1')"></div>
            </li>
            <li>
              <div v-html="$t('widgets.PagesThankYou.sectionDescr2')"></div>
            </li>
            <li>
              <div>
                <h3>{{ $t('widgets.PagesThankYou.sectionTitle2') }}</h3>

                <div class="follow cf">
                  <a
                    href="https://www.facebook.com/customusbdrives"
                    target="_blank"
                    class="followBlock facebook-like"
                  >
                    <h4 class="small">
                      {{ $t('widgets.PagesThankYou.likeUsOn') }} <span style="color:#3b5998;">Facebook</span>
                    </h4>
                    <div
                      class="fb-like"
                      data-href="https://www.facebook.com/customusbdrives"
                      data-width="100"
                      data-layout="button_count"
                      data-action="like"
                      data-show-faces="false"
                      data-share="false"
                    ></div>
                  </a>
                  <a
                    href="https://www.customusb.com"
                    target="_blank"
                    class="followBlock facebook-share"
                  >
                    <h4 class="small">
                      {{ $t('widgets.PagesThankYou.shareOurHomepage') }}
                    </h4>
                    <div
                      class="fb-share-button"
                      data-href="https://www.customusb.com"
                      data-layout="button_count"
                      data-show-faces="false"
                      data-share="true"
                    ></div>
                  </a>
                </div>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  middleware: [
    function () {
      const { confGlobal } = useConfig()

      if (confGlobal.site !== 'customusb') {
        throw createError({
          statusCode: 404
        })
      }
    }
  ],
  key: 'start'
})

/**
* Meta Tags
*/
useHead({
  title: 'Thank You!',
  meta: [
    { name: 'description', content: '' }
  ]
})
</script>

<style lang="scss" scoped>
.invoice {
  display: block;
  width: 100%;
  height: auto;
  padding: 0;
  text-rendering: optimizeLegibility;
  &__title {
    display: block;
    width: 100%;
    padding-bottom: 2em;
    text-align: center;
    h1.success i:before {
      display: inline-block !important;
      width: 3.75rem;
      height: 3.75rem;
      margin: 0 10px 10px 0;
      font-size: 3rem;
      font-weight: 600;
      line-height: 3.75rem;
      text-shadow: none;
      vertical-align: middle;
      background: #27ae60;
      border-radius: 50%;
    }
  }
  &__contents {
    display: block;
    height: auto;
    padding: 0;
    border: 1px dashed #ccc;
    h2 {
      display: block;
      width: 100%;
      padding: 1.25rem;
      margin: 0;
      color: red;
      font-size: 24px;
      font-weight: 500;
      text-align: center;
      border-bottom: 1px dashed #ccc;
    }
    ol {
      width: 100%;
      padding: 0;
      margin: 10px auto 20px;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      li {
        width: 75%;
        padding: 8px 0;
        margin: 0 auto;
        color: #666;
        text-align: justify;
        border-bottom: 1px dotted #ddd;
        div {
          font-size: 13px;
          font-weight: 400;
          line-height: 1.5;
        }
      }
    }
    h3 {
      font-size: 20px;
    }
    p {
      color: #666;
    }
    .follow {
      & > .followBlock {
        float: left;
        display: block;
        overflow: hidden;
        width: 49%;
        height: 100%;
        padding: 1rem;
        margin: 0 1% 0 0;
        text-align: center;
        background: #f5f5f5;
        border-radius: 5px;
      }
    }
  }
}
</style>
